import { test, expect, is, not, curry } from "@benchristel/taste"
import { render } from "preact"
import { waitForMilliseconds } from "./wait"

// TODO: extract to a library when there are three below
export const matches = (regex: RegExp, string: string) => regex.test(string)
export const isA = curry(
  (constructor: () => any, thing: any) => thing instanceof constructor,
  "isA",
)
// see above

test("isA", {
  "says a function is a Function"() {
    expect(() => {}, isA, Function)
  },

  "says an object isn't a Function"() {
    expect({}, not(isA), Function)
  },
})

test("matches", {
  "given a string that matches the regex"() {
    expect(matches(/a/, "a"), is, true)
  },
  "given a string that doesn't match the regex"() {
    expect(matches(/a/, "bullseye"), is, false)
  },
})

export function uiTest(testBody: (el: HTMLDivElement) => unknown) {
  return async function () {
    const div = document.createElement("div")
    await testBody(div)
    render(null, div) // free memory
  }
}

export type Spy<F extends AnyFunc> = {
  (...args: Parameters<F>): void
  calls: Array<Parameters<F>>
}

export function spy<F extends AnyFunc>(): Spy<F> {
  const calls: Array<Parameters<F>> = []
  const spyFunc = function (...args: Parameters<F>) {
    calls.push(args)
  }
  spyFunc.calls = calls
  return spyFunc
}

type AnyFunc = (...args: any) => any

export async function promisesToClear() {
  await waitForMilliseconds(0)
}
